import React from 'react'

import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  heading: string;
  message: string;
}

function AuthSuccess(props: Props) {
  const {
    message,
    heading,
  } = props

  return (
    <>
      <Heading variant="heading3">
        {heading}
      </Heading>
      <BodyText variant="medium">
        {message}
      </BodyText>
    </>
  )
}

export default React.memo(AuthSuccess)
